import React from 'react';
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import {sendInput} from "game/app/actions/game-instance-actions";

class IntroNode extends React.Component {
    render() {
        return (
            <div>
                <h1>Intro Node</h1>
                <button onClick={() => this.props.sendInput(this.props.gameInstance.instance.id, { type: 'next' })}>Next</button>
            </div>
        )
    }
}

function mapStateToProps(state,ownProps) {
    return {
        gameInstance: state.gameInstance
    };
}

function matchDispatchToProps(dispatch){
    return bindActionCreators({
        sendInput: sendInput
    }, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(IntroNode);
